import { Text, TextField } from "@merge-api/merge-javascript-shared";
import { handleTimeInputChange } from "../../../../../blueprint-editor/left-panel/shared/left-panel-helpers";

interface OverrideLastRunAtFieldProps {
  value: string | undefined;
  onChange: (value: string) => void;
  error: boolean;
  errorText: string | undefined;
  setError: (value: boolean) => void;
  setErrorText: (value: string | undefined) => void;
}

const OverrideLastRunAtField = ({
  value,
  onChange,
  error,
  errorText,
  setError,
  setErrorText,
}: OverrideLastRunAtFieldProps) => {
  const handleChange = (inputValue: string) =>
    handleTimeInputChange(inputValue, onChange, setError, setErrorText);

  return (
    <div>
      <Text variant="h6">Override last run at</Text>
      <Text as="div" className="text-gray-40 mb-2">
        Specify the timestamp, using ISO 8601 format, for which this blueprint was last modified at
      </Text>
      <TextField
        type="text"
        title="Override last run at"
        placeholder="Example: 2025-06-21T00:00:00Z"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        error={error}
        errorText={errorText}
      />
    </div>
  );
};

export default OverrideLastRunAtField;
